import React, { useEffect } from "react";
import styled from "@emotion/styled";
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet-async";

import {
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Divider as MuiDivider,
  Typography,
  Grid,
  CircularProgress,
} from "@mui/material";
import { Box, spacing } from "@mui/system";
import useAppSelector from "../../hooks/useAppSelector";
import { fetchRoads } from "../../redux/slices/road";
import useAppDispatch from "../../hooks/useAppDispatch";
import useAuth from "../../hooks/useAuth";

import { MapComponent } from "./mapComponents/MapComponent";
import { fetchUsers } from "../../redux/slices/user";
import { fetchProperties } from "../../redux/slices/property";

const Divider = styled(MuiDivider)(spacing);

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

export const isPropertyInUserAssociation = (
  propertyFeature: any,
  propertiesList: any[],
  associationId: number
): number | null => {
  const targetId = propertyFeature.properties?.kiinteistotunnuksenEsitysmuoto;

  const match = propertiesList.find((prop) => {
    const belongsToAssociation = prop.user?.associations?.some(
      (assoc: any) => assoc.id === associationId
    );
    return prop.code === targetId && belongsToAssociation;
  });

  return match?.id ?? null;
};

export const getPropertyById = (
  propertyId: any,
  properties: any[]
): any | null => {
  const match = properties.find((prop) => prop.id == propertyId);
  return match ?? null;
};

export const getMatchingFeature = (
  propertyFeature: any,
  propertiesList: any[],
  associationId: number
): any | null => {
  const targetId = propertyFeature.properties?.kiinteistotunnuksenEsitysmuoto;

  const match = propertiesList.find((prop) => {
    const belongsToAssociation = prop.user?.associations?.some(
      (assoc: any) => assoc.id === associationId
    );
    return prop.code === targetId && belongsToAssociation;
  });

  return match ?? null;
};

const MapPage: React.FC = () => {
  const { currentUser } = useAuth();
  const dispatch = useAppDispatch();
  const { status: roadStatus, roads } = useAppSelector((state) => state.road);
  const { status: propertyStatus, properties } = useAppSelector(
    (state) => state.property
  );

  const associationId =
    currentUser?.activeAssociation?.id || currentUser?.associations?.[0]?.id;

  useEffect(() => {
    if (associationId) {
      dispatch(fetchRoads(associationId));
      dispatch(fetchProperties(associationId));
      dispatch(fetchUsers({ associationId }));
    }
  }, [dispatch, currentUser]);

  return (
    <>
      <Helmet title="Kartta" />
      <Typography variant="h3" gutterBottom display="inline">
        Kartta
      </Typography>

      <Breadcrumbs aria-label="Breadcrumb" sx={{ mt: 2 }}>
        <Link component={NavLink} to="/">
          Etusivu
        </Link>
        <Typography>Kartta</Typography>
      </Breadcrumbs>

      <Divider sx={{ my: 6 }} />

      <Grid container spacing={6}>
        <Grid item xs={12}>
          {roadStatus && propertyStatus === "loading" ? (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="50vh"
            >
              <CircularProgress />
            </Box>
          ) : (
            <MapComponent
              roads={roads}
              properties={properties}
              type={"properties"}
            />
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default MapPage;
